import BasicModel from './BasicModel';

class ProfileModel extends BasicModel {
  id = 0;

  name = null;

  soname = null;

  surname = null;

  login = null;

  email = null;

  status = null;

  avatar = null;

  group_id = null;

  roles = [];

  permissions = [];
}

export default ProfileModel;
